
import { RewardsEstimator} from './pages/RewardsEstimator'

import {
  createBrowserRouter,
} from "react-router-dom";
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { AllCards } from './pages/AllCards';
import { HomePage } from './pages/HomePage';
import AppSplashPage from './pages/AppSplashPage';
import BetaPage from './pages/BetaPage';

export const router = createBrowserRouter([
  {
    path: "/",
    // element: <HomePage />
    element: <AppSplashPage />
    // element: <RewardsEstimator />
  },
  {
    path: '/beta',
    element: <BetaPage />
  },
  {
    path: '/cards',
    element: <HomePage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />
  },
  // {
  //   path: "/terms-of-service",
  //   element: <TermsOfService />
  // }
  {
    path: "/all-cards",
    element: <AllCards />
  }
]);